module.exports = __webpack_public_path__ + "static/img/al1.82f3663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al1.jpg
// module id = e4CN
// module chunks = 0